import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import { API_BASE_URL } from "./config.js";
import { isGuestMode } from "./utils/guestMode.js";
import "./assets/styles/global.css";
import "./assets/styles/dark-mode.css";

Vue.config.productionTip = false;

// Configura axios per inviare automaticamente i cookie
axios.defaults.withCredentials = true;

// Usa la stessa configurazione sia in sviluppo sia nella build di produzione.
axios.defaults.baseURL = API_BASE_URL || "/";

// Interceptor per refresh automatico del token
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.isGuestBlocked) {
      return Promise.reject(error);
    }

    if (isGuestMode() && error.response?.status === 401) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/refresh") &&
      !originalRequest.url?.includes("/login") &&
      !originalRequest.url?.includes("/clerk/")
    ) {
      originalRequest._retry = true;

      try {
        // Chiama /refresh
        await axios.post("/refresh"); // usa relativo se baseURL = '/'
        // Riprova la richiesta originale
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token fallito:", refreshError);
        // Pulisci e redirect
        localStorage.clear();
        router.push("/users-login");
        return Promise.reject(refreshError);
      }
    }

    // Gestisci altri errori (opzionale)
    if (error.response && !error.config?.skipGlobalErrorLog) {
      console.error("Errore API:", error.response.status, error.response.data);
    }

    return Promise.reject(error);
  }
);
axios.interceptors.request.use(
  (config) => {
    const method = (config.method || "get").toLowerCase();
    const readOnlyMethods = ["get", "head", "options"];
    const guestAllowedAuthUrls = [
      "/login",
      "/register_studio",
      "/utenti",
      "/studi/check",
    ];
    const url = String(config.url || "");

    if (
      isGuestMode() &&
      !readOnlyMethods.includes(method) &&
      !guestAllowedAuthUrls.some((allowedUrl) => url.includes(allowedUrl))
    ) {
      const error = new Error(
        "Modalità ospite: azione disponibile solo dopo la registrazione o il login."
      );
      error.isGuestBlocked = true;
      error.config = config;
      error.response = {
        status: 403,
        data: {
          message:
            "Modalità ospite: azione disponibile solo dopo la registrazione o il login.",
        },
      };
      return Promise.reject(error);
    }

    // Per debug: logga le richieste
    // console.log("Request:", config.method.toUpperCase(), config.url);
    return config;
  },
  (error) => Promise.reject(error)
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
